import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '../../../shared/shared.module';
import { ReportDatatableModule } from '../../../shared/components/report-datatable/report-datatable.module';
import { ReportsApiService } from '../reports.apiservice';
import { ReportsBrandDashboardComponent } from './reports-brand-report.component';

@NgModule({
  declarations: [ReportsBrandDashboardComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ReportDatatableModule
  ],
  providers: [ReportsApiService],
  exports: [ReportsBrandDashboardComponent]
})
export class ReportsBrandReportModule {}
